export default __webpack_public_path__ + "static/media/99.f5baac6b.png";